import { Checkout as CiclCheckout } from "@comparaonline/cicl-funnel-schema";
import { Checkout as CicoCheckout, CheckoutStatus } from "@comparaonline/cico-funnel-schema";
import { Offer } from "@comparaonline/offers-models";
import { ProductWithOffer } from "../../../core/types";
import { Schema } from "@comparaonline/quoter-schema";
import {
  FirebaseClient,
  FunnelName,
  FunnelCollectionName,
  createFunnelWithCollections,
  getFunnelCollection
} from "../../../modules/firebase";
import { NEW_CHECKOUT } from "..";
import config, { getConfig } from "../../../../config/app";
import { isInsuranceByKm } from "../isInsuranceByKm";
import { createOrderThroughMarketplaceBff } from "../../../api/orders";

type CreateFunnel = (input: {
  checkout: CiclCheckout | CicoCheckout;
  firebase: FirebaseClient;
  offer: Offer;
  name: FunnelName;
  quote: Schema.CiclFormInput | Schema.CicoQuote;
  countryCode: string;
}) => Promise<Record>;

export const createFunnel: CreateFunnel = async ({
  checkout,
  firebase,
  offer,
  name,
  quote,
  countryCode
}) => {
  if (
    getConfig(`marketplaceBff.checkout.${countryCode}.enabled`) === true &&
    name === FunnelName.Cicl
  ) {
    await createOrderThroughMarketplaceBff(offer.formId, offer.id, countryCode);
  }

  await createFunnelWithCollections({
    documentId: offer.formId,
    name,
    firebase,
    collections: [
      {
        name: FunnelCollectionName.Checkout,
        data: checkout
      },
      {
        name: FunnelCollectionName.Offer,
        data: offer
      },
      {
        name:
          name === FunnelName.Cico ? FunnelCollectionName.Quote : FunnelCollectionName.QuoteForm,
        data: quote
      }
    ]
  });
};

export const hasInternalCheckout = (businessCode: string, product: ProductWithOffer): boolean => {
  const {
    checkout: { businessCodeAllowList }
  } = config;
  if (businessCodeAllowList.includes(businessCode) || isInsuranceByKm(product)) return true;
  if (product.productAttributes) {
    const attr = product.productAttributes.find(pa => pa.entity.code === NEW_CHECKOUT);
    return (attr && attr.value) || false;
  }
  return false;
};

export const hasACompletedCheckout = async (quoteID: string, firebase: FirebaseClient): boolean => {
  const checkout = await getFunnelCollection({
    firebase,
    documentId: quoteID,
    funnelName: FunnelName.Cicl,
    name: FunnelCollectionName.Checkout
  }).catch(e => {
    return false;
  });

  return checkout && checkout.status === CheckoutStatus.SUCCESS;
};
